var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfraPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-power-5630433",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.687,
    height: 253.839,
    viewBox: "0 0 160.687 253.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M23.844,152.306H77.66L58.354,242.539a9.141,9.141,0,0,0,5.283,10.448,9.547,9.547,0,0,0,3.921.846,9.15,9.15,0,0,0,7.4-3.828l94.222-127.978a12.851,12.851,0,0,0-10.33-20.482H105.038l19.306-90.233A9.146,9.146,0,0,0,119.077.867a9.12,9.12,0,0,0-11.324,2.961l-94.239,128a12.855,12.855,0,0,0,10.33,20.482ZM20.312,136.84,114.568,8.849a.761.761,0,0,1,.618-.368,1.015,1.015,0,0,1,.423.1.753.753,0,0,1,.491.96L95.668,104.886A4.23,4.23,0,0,0,99.809,110h59.044a4.391,4.391,0,0,1,3.532,7.005L68.134,245a.736.736,0,0,1-1.036.271.753.753,0,0,1-.491-.96h0L87.03,148.964a4.23,4.23,0,0,0-4.141-5.118H23.844a4.391,4.391,0,0,1-3.532-7.005Z",
    transform: "translate(-11.007 0.006)",
    fill: "#eff3fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfraPower);
export default __webpack_public_path__ + "static/media/infra-power.40788e9ed910f7867ce6889b7d994da6.svg";
export { ForwardRef as ReactComponent };